export var FieldMixin = {
  inject: {
    vanField: {
      default: null
    }
  },
  watch: {
    value: function value() {
      var field = this.vanField;

      if (field) {
        field.resetValidation();
        field.validateWithTrigger('onChange');
      }
    }
  },
  created: function created() {
    var field = this.vanField;

    if (field && !field.children) {
      field.children = this;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/_vant@2.12.25@vant/es/mixins/field.js
// module id = 31
// module chunks = 38